// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import articleFeedbackEntity from './entities/article-feedback.json';
import articleFeedbackMenu from '../pages/article-feedback/menu.json';
import articleFeedbackFullForm from '../pages/article-feedback/forms/full.json';
import articleFeedbackContextForm from '../pages/article-feedback/forms/context.json';
import articleFeedbackMiniForm from '../pages/article-feedback/forms/mini.json';
import articleFeedbackLookupForm from '../pages/article-feedback/forms/lookup.json';
import articleFeedbackTableView from '../pages/article-feedback/views/table.json';
import articleFeedbackCardsView from '../pages/article-feedback/views/cards.json';
import articleFeedbackCalendarView from '../pages/article-feedback/views/calendar.json';
import articleFeedbackDashboardView from '../pages/article-feedback/views/dashboard.json';

/** Тип запису «Відгук на статтю» зі сторінками пакета: меню, форми та подання з pages/article-feedback/. */
export const articleFeedbackDefinition: IRecordTypeDefinition = {
  ...articleFeedbackEntity,
  views: assembleViewSet({
      table: articleFeedbackTableView,
      cards: articleFeedbackCardsView,
      calendar: articleFeedbackCalendarView,
      dashboard: articleFeedbackDashboardView,
  }),
  form: articleFeedbackFullForm,
  forms: { full: articleFeedbackFullForm, context: articleFeedbackContextForm, mini: articleFeedbackMiniForm, lookup: articleFeedbackLookupForm },
  menu: articleFeedbackMenu,
} as IRecordTypeDefinition;
